import FormWidget from "../form-widget.js";

class ShowPasswordWidget extends FormWidget {
    public override process() {

        if(!this.element.parentElement?.classList.contains('input-group')) {
            const wrapEl = document.createElement('div');
            this.element.after(wrapEl);
            wrapEl.classList.add('input-group');
            wrapEl.append(this.element);
        }

        const inputGroupEl = document.createElement('div');
        inputGroupEl.classList.add('input-group-text', 'p-0');
        this.element.after(inputGroupEl);

        const showBtnEl = document.createElement('button');
        showBtnEl.setAttribute('type', 'button');
        showBtnEl.setAttribute('class', 'btn btn-link');
        showBtnEl.setAttribute('title', window.ThiemeCore.Lang.translate('showPassword', null, 'Show password'));
        showBtnEl.setAttribute('tabindex', '999');
        const iconEl = document.createElement('i');
        iconEl.setAttribute('class', 'bi bi-eye');
        showBtnEl.append(iconEl);
        showBtnEl.addEventListener('click', (ev: MouseEvent) => {
            if(this.element.getAttribute('type') === 'password') {
                this.element.setAttribute('type', 'text');
                iconEl.setAttribute('class', 'bi bi-eye-slash');
                showBtnEl.setAttribute('title', window.ThiemeCore.Lang.translate('hidePassword', null, 'Hide password'));
            } else {
                iconEl.setAttribute('class', 'bi bi-eye');
                this.element.setAttribute('type', 'password');
                showBtnEl.setAttribute('title', window.ThiemeCore.Lang.translate('showPassword', null, 'Show password'));
            }
            ev.preventDefault();
        });

        inputGroupEl.append(showBtnEl);
    }
}

export default ShowPasswordWidget;
